import dayjs, { Dayjs } from 'dayjs';
import tz from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(tz);

export namespace DateTimeUtils {
  const timeZone = 'Asia/Bangkok';
  export const defaultFormat = 'DD MMM YYYY HH:mm';

  export const format = (date: Date | string | undefined, fm = 'YYYY-MM-DD'): string => (
    date ? dayjs(date).tz(timeZone).format(fm) : '-'
  );

  export const dateTimeFormat = (date: Date | undefined): string => {
    const fm = 'DD MMM YYYY HH:mm:ss';
    return date ? format(date, fm) : '-';
  };

  export const dateFormatStartWithDay = (date: Date | string | undefined): string => {
    const fm = 'DD MMM YYYY';
    return date ? format(date, fm) : '-';
  };

  export const dateFormat = (date?: Date | string): string => {
    const fm = 'YYYY-MM-DD';
    return date ? format(date, fm) : '-';
  };

  export const timeFormat = (date: Date | undefined): string => {
    const fm = 'HH:mm:ss';
    return date ? format(date, fm) : '-';
  };

  export const combineDateTimeFormat = (date: Date, time: Date): string | undefined => {
    if (!date || !time) { return undefined; }
    const dateFormated = dateFormat(date);
    const timeFormated = timeFormat(time);
    return `${dateFormated} ${timeFormated}`;
  };

  export const startOfToday = (): Date =>
    dayjs().startOf('day').toDate();

  export const endOfToday = (): Date =>
    dayjs().endOf('day').toDate();

  export const getTimeStamp = (): number => dayjs(new Date()).unix();

  export const startTime = (): Dayjs =>
    dayjs('00:00:00', 'HH:mm:ss');

  export const endTime = (): Dayjs =>
    dayjs('23:59:59', 'HH:mm:ss');

  export const extractTime = (dateTime: Date): Dayjs => {
    const time = timeFormat(dateTime);
    return dayjs(time, 'HH:mm:ss');
  };

  export const dateWithTime = (time: string): Date => {
    const [hours, minutes, seconds] = time.split(':');
    const newDateWithTime = new Date();
    newDateWithTime.setHours(parseInt(hours, 10));
    newDateWithTime.setMinutes(parseInt(minutes, 10));
    newDateWithTime.setSeconds(parseInt(seconds, 10));

    return newDateWithTime;
  };
}
